import produce from 'immer';

// TYPES
import { Types, ConsultaMudancaCategoria } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultaMudancaCategoria = {
	status: 0,
	data: null,
	dataError: null,
	requestData: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaMudancaCategoria {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_MUDANCA_CATEGORIA_CNH_REQUEST: {
				draft.status = 100;
				draft.data = INITIAL_STATE.data;
				draft.requestData = INITIAL_STATE.requestData;
				break;
			}

			case Types.CONSULTA_MUDANCA_CATEGORIA_CNH_SUCCESS: {
				draft.status = action.payload.response.status;
				draft.requestData = action.payload.request;
				draft.data = action.payload.response.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			case Types.CONSULTA_MUDANCA_CATEGORIA_CNH_FAILURE: {
				draft.status = action.payload.response.status;
				draft.requestData = action.payload.request;
				draft.data = INITIAL_STATE.data;
				draft.dataError = action.payload.response.data;
				break;
			}

			case Types.CONSULTA_MUDANCA_CATEGORIA_CNH_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.requestData = INITIAL_STATE.requestData;
				draft.data = INITIAL_STATE.data;
				draft.dataError = INITIAL_STATE.dataError;
				break;
			}

			default:
		}
	});
}
